import removeAccents from 'remove-accents';

// Same normalisation as the search filter in App.js, so "Åsa.Jonsson" and
// "asa jonsson" end up as the same key.
const normalise = ( identifier ) => {
    return removeAccents( identifier.toLowerCase().replace( /[.-]/g, ' ' ) ).trim();
};

// Unicator identities can look like "host/anna.andersson" or "anna.andersson@domain".
const identityKey = ( identity ) => {
    return normalise( identity.replace( /^host\//i, '' ).split( '@' )[ 0 ] );
};

// ?people=anna.andersson,erik.eriksson -> ['anna andersson', 'erik eriksson']
export const parsePeople = ( value ) => {
    if ( !value ) {
        return [];
    }

    const keys = value
        .split( ',' )
        .map( identityKey )
        .filter( Boolean );

    return keys.filter( ( key, index ) => keys.indexOf( key ) === index );
};

export const deviceMatchesPeople = ( device, people ) => {
    return people.includes( identityKey( device.identity ) );
};
